import { Tag, Typography } from "antd";
import React from "react";
import { SmileOutlined } from "@ant-design/icons";
import { FolderChange } from "../../../redux/interfaces/folder.types.ts";
import { gray, lightBlue } from "../../../utils/theme/colors.ts";

interface Props {
  change: FolderChange;
}

export const HistoryItemActive: React.FC<Props> = ({ change }) => {
  const previousActive = change.is_active?.previous ? "Activo" : "Inactivo";
  const currentActive = change.is_active?.actual ? "Activo" : "Inactivo";

  const prevActive = change.is_active?.previous || null;
  const currActive = change.is_active?.actual || null;

  const prevIcon = change.is_active?.previous ? (
    <SmileOutlined />
  ) : (
    <SmileOutlined rotate={180} />
  );
  const actualIcon = change.is_active?.actual ? (
    <SmileOutlined />
  ) : (
    <SmileOutlined rotate={180} />
  );

  return (
    <div className="flex items-center font-medium space-x-2 my-1">
      {currActive !== prevActive && (
        <div className="flex flex-wrap">
          <Typography.Text className="font-medium">
            {"Estado:"}&nbsp;
          </Typography.Text>
          {
            <div className="mr-1">
              <Tag color={prevActive ? lightBlue : gray} icon={prevIcon}>
                {previousActive}
              </Tag>
              <span className="text-gray-500">→</span>
            </div>
          }
          <Tag
            color={change.is_active?.actual ? lightBlue : gray}
            icon={actualIcon}
          >
            {currentActive}
          </Tag>
        </div>
      )}
    </div>
  );
};
